import { useEffect, useState, useRef } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getResourceList } from '../../models/BaseModel'

import './../../scss/Header.scss'

export default function Header() {
    const [menuLinks, setMenuLinks] = useState([])
    const [logoItems, setLogoItems] = useState([])
    const {isLoading, isSuccess, isError, data} = useQuery({
        queryKey: ['header', {resourceName: 'header'}], 
        queryFn: getResourceList
    });
    const sentinelRef = useRef()

    useEffect(() => {
        if (isSuccess) {
            setMenuLinks(data.get('menuLinks'))
            setLogoItems(data.get('logoItems'))
        }
    }, [isError, isSuccess, data])

    useEffect(() => {
        if (!sentinelRef.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                // When sentinel is visible (at top), remove scrolled class
                // When sentinel is not visible (scrolled past), add scrolled class
                document.documentElement.classList.toggle('scrolled', !entry.isIntersecting);
            },
            { 
                threshold: 0,
                rootMargin: '0px 0px 0px 0px'
            }
        );

        observer.observe(sentinelRef.current);

        return () => {
            observer.disconnect();
            document.documentElement.classList.remove('scrolled');
        };
    }, []);
    
    return (<>
        {/* Sentinel element to detect scroll position */}
        <div ref={sentinelRef} className="scroll-sentinel" />
        <header>
            <div className="desktop-nav page-hero">
                <content-constrainer class="content-constrainer--no-border content-constrainer--no-padding">
                    <div className="page-hero__content">
                            <img 
                                src="https://ewscripps.brightspotcdn.com/1a/18/0296aa52411992eb24e657bf120b/sports-logo-2x.png" 
                                alt="Scripps Sports Logo" 
                                className='hero-logo' 
                                width="622" 
                                height="120" 
                            />
                            <p>
                                Scripps Sports Network is your home for live games and the stories behind them. This national channel delivers nonstop action, behind-the-scenes access, and original shows celebrating the game, the athletes, and the communities that love them. From the energy of the arena to the emotion of real stories, we bring fans closer to what they love most about the game.
                            </p>
                            <a 
                                href="#find-us" 
                                className="find-where-to-watch-link" 
                                aria-label="Find Where to Watch - Skip to main content"
                            >
                                Where to Watch
                            </a>
                    </div>
                    {/* <div className='mobile-hero-image'>
                        <img 
                            src="https://ewscripps.brightspotcdn.com/1a/18/0296aa52411992eb24e657bf120b/sports-logo-2x.png" 
                            alt="Scripps Sports Logo" 
                            className='hero-logo' 
                            width="622" 
                            height="120" 
                        />  
                    </div> */}
                </content-constrainer>
            </div>
            <nav className="mobile-nav">
                <img 
                    src="https://ewscripps.brightspotcdn.com/1a/18/0296aa52411992eb24e657bf120b/sports-logo-2x.png" 
                    alt="Scripps Sports Logo" 
                    className='mobile-nav__logo' 
                    width="158" 
                    height="30" 
                />
            </nav>
        </header>
    </>)
}
